import * as React from "react";
import ToggleButton from "../commons/components/buttons/ToggleButton";
import { Feature, getFeatureI18nKey } from "./FeaturesState";
import sfetch from "../commons/utils/super-fetch";
import { ModalWarning } from "../commons/components/modal/ModalWarning";

interface FeatureProps {
  feature: Feature;
  enabled: boolean;
  editable: boolean;
}

export interface FeaturesSelectorProps {
  features: { [key: string]: FeatureProps };
  apiUrl: string;
  hasActiveSubscription?: boolean;
  hasDso: boolean;
}

interface FeaturesSelectorState {
  features: { [key: string]: boolean };
  errorMessage?: string;
  showWarningPaymentSubscription?: boolean;
}

export default class FeaturesSelector extends React.Component<
  FeaturesSelectorProps,
  FeaturesSelectorState
> {
  constructor(props: FeaturesSelectorProps) {
    super(props);
    this.state = {
      features: this.buildFeatureStates(props.features),
      errorMessage: null,
    };
  }

  private buildFeatureStates(features: { [key: string]: FeatureProps }): {
    [key: string]: boolean;
  } {
    const states = {};
    Object.values(features).forEach(
      (featureProps) => (states[featureProps.feature] = featureProps.enabled)
    );
    return states;
  }

  render() {
    return (
      <div className="content-block">
        {this.state.showWarningPaymentSubscription ? (
          <ModalWarning
            action={async () => {
              this.setState({ showWarningPaymentSubscription: false });
            }}
            title={i18n["Page.PracticeManagement.Features.ReportCreation.Warning"]}
            actionButtonLabel={i18n["Global.Close"]}
          />
        ) : null}
        <div className="panel with-shadow">
          {this.state.errorMessage ? (
            <div className="error-message">{this.state.errorMessage}</div>
          ) : null}
          <div className="panel-title">{i18n["Page.PracticeManagement.Features"]}</div>
          <div className="v-flex">
            {Object.values(this.props.features).map((featureProps) => (
              <div className="feature h-flex space-between" key={featureProps.feature}>
                <p>{i18n[getFeatureI18nKey(featureProps.feature)]}</p>
                <ToggleButton
                  value={this.state.features[featureProps.feature]}
                  onChange={(newValue) => {
                    this.setState({ errorMessage: null });
                    if (featureProps.editable) {
                      if (
                        featureProps.feature == Feature.ASSESSMENT_CREATION &&
                        !this.props.hasDso
                      ) {
                        this.setState({
                          errorMessage:
                            "To enable this feature, user should have an active subscription. This cannot be done manually",
                        });
                      } else {
                        this.processChange(featureProps.feature, newValue, false);
                      }
                    }
                  }}
                  disabled={!featureProps.editable}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  private processChange(feature: Feature, enabled: boolean, isConfirmed: boolean) {
    if (
      feature === Feature.ASSESSMENT_CREATION &&
      !enabled &&
      this.props.hasActiveSubscription &&
      !isConfirmed
    ) {
      this.setState({ showWarningPaymentSubscription: true });
      return;
    }
    sfetch(this.props.apiUrl, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        feature: feature,
        enabled,
      }),
    })
      .then(() =>
        this.setState({
          features: { ...this.state.features, [feature]: enabled },
        })
      )
      .catch(() =>
        this.setState({
          errorMessage: i18n["Global.Status.technical_error"],
        })
      );
  }
}
